import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'

const firebaseConfig = {
  apiKey: 'AIzaSyDdVxWGSKZGcJP2rRPRVFL_iXaBPdHk338',
  authDomain: 'extasy-untold.firebaseapp.com',
  projectId: 'extasy-untold',
  storageBucket: 'extasy-untold.appspot.com',
  messagingSenderId: '89106202934',
  appId: '1:89106202934:web:c4e21a97421c8652f5f397',
  measurementId: 'G-3S3D7CWKX9',
}

const app = initializeApp(firebaseConfig)
const db = getFirestore(app)
export default db
